<template>
	<reportFormWrap
		ref="reportFormWrap"
		:reportid="reportid"
		:orderMenu="orderMenu"
		:settingCols="settingCols"
		:getFiltersParams="getFiltersParams"
		:reportFormUrl="reportFormUrl"
		:getCustomThroughParams="getCustomThroughParams">
		<FiltersBox slot="filters" ref="filters" @inputEnter='inputEnter'></FiltersBox>
	</reportFormWrap>
</template>

<script>
import { cols } from '@/js/reportform/activitySummary.js'
import { orderMenu } from '@/js/reportform/reportformCommon.js'
import reportFormWrap from '@/components/reportform/common/ReportFormWrap.vue'
import FiltersBox from '@/components/reportform/activitySummary/FiltersBox.vue'
export default {
	name: 'activitySummary',
	components: {
		reportFormWrap,
		FiltersBox
	},
	data () {
		return {
			reportid: 'SPXS_13100011',
			settingCols: cols,
			reportFormUrl: `${this.$fxBaseApi.urlQIVShop}/reportScheme/businessDisTypeSumReport`,
			orderMenu: orderMenu
		}
	},
	mounted () {
		this.$refs.reportFormWrap.initReportForm()
	},
	methods: {
		inputEnter () {
			return this.$refs.reportFormWrap.searchHandler()
		},
		getFiltersParams () {
			return this.$refs.filters.getFiltersParams()
		},
		getCustomThroughParams () {
			return this.$refs.filters.getFiltersDate()
		}
	}
}
</script>
